// frontend-react/src/utils/csvUtils.ts
import type { ReviewItem } from '../types';

/** 防 CSV Injection：加引號或前置單引號 */
const csvEscape = (text: string): string => {
  if (!text) return '';
  const str = String(text);
  if (/^[=+\-@\t\r]/.test(str)) {
    return `"'${str.replace(/"/g, '""')}"`;
  }
  const needsQuotes = /[",\n\r]/.test(str);
  return needsQuotes ? `"${str.replace(/"/g, '""')}"` : str;
};

const getRiskLevelLabel = (level?: string): string => {
  if (level === 'high') return '高風險';
  if (level === 'medium') return '中風險';
  if (level === 'low') return '低風險';
  return '';
};

/**
 * 將 ReviewItem 陣列轉換為 CSV 字串（帶 BOM header，同現有下載邏輯）。
 * 可在前端下載 CSV 或傳給後端驗測 API 使用。
 */
export const generateReviewCsvString = (results: ReviewItem[]): string => {
  const header = ['項次', '頁碼', '行數', '風險等級', '規則', '原文', '建議'].join(',');
  const rows = results.map((item, index) =>
    [
      index + 1,
      csvEscape(item.page),
      csvEscape(item.line || ''),
      csvEscape(getRiskLevelLabel(item.risk_level)),
      csvEscape(`第${item.item_id}條 ${item.rule}`),
      csvEscape(item.origin),
      csvEscape(item.suggestion),
    ].join(',')
  );
  return [header, ...rows].join('\n');
};
